const ALL_CACHES = new Set();
// re‐entrancy guard to prevent infinite recursive broadcasts,
// "Weak" avoids accidentally pinning caches in memory just because they were briefly “active”
const active = new WeakSet();
// attaches cache broadcast to native modify/evict functions
// so that such operations would work across all partner caches
export const attachBroadcast = (cache) => {
    ALL_CACHES.add(cache);
    // Bind the originals
    const originalModify = cache.modify.bind(cache);
    const originalEvict = cache.evict.bind(cache);
    const originalUpdateQuery = cache.updateQuery.bind(cache);
    // override modify
    cache.modify = ((options) => {
        if (active.has(cache)) {
            return originalModify(options);
        }
        active.add(cache);
        try {
            const result = originalModify(options);
            ALL_CACHES.forEach((c) => {
                if (c !== cache) {
                    c.modify(options);
                }
            });
            return result;
        }
        finally {
            active.delete(cache);
        }
    });
    // override evict
    cache.evict = ((options) => {
        if (active.has(cache)) {
            return originalEvict(options);
        }
        active.add(cache);
        try {
            const result = originalEvict(options);
            ALL_CACHES.forEach((c) => {
                if (c !== cache) {
                    c.evict(options);
                }
            });
            return result;
        }
        finally {
            active.delete(cache);
        }
    });
    cache.updateQuery = ((options, updateFn, params) => {
        if (active.has(cache)) {
            return originalUpdateQuery(options, updateFn);
        }
        active.add(cache);
        try {
            const result = originalUpdateQuery(options, updateFn);
            if (params?.broadcastAll) {
                ALL_CACHES.forEach((c) => {
                    if (c !== cache) {
                        c.updateQuery(options, updateFn);
                    }
                });
            }
            return result;
        }
        finally {
            active.delete(cache);
        }
    });
};
